import type {ErrorResponse} from "./types";

export class HttpError extends Error {
    constructor(
        public readonly status: number,
        public readonly data?: ErrorResponse,
        message?: string,
    ) {
        super(message ?? `HTTP ${status}`);
        this.name = 'HttpError';
        // for ES5
        Object.setPrototypeOf(this, HttpError.prototype);
    }
}